export const DURATION_UNIT_OPTIONS = [
  { value: "minute", labelKey: "experiences.ticketed_schedule.minutes" },
  { value: "hour", labelKey: "experiences.ticketed_schedule.hours" }
]

// The duration unit a single-day listing starts with — the unit picker always shows one as chosen.
export const DEFAULT_DURATION_UNIT = DURATION_UNIT_OPTIONS[0].value

// A multi-day shared tour has no duration inputs (its length is the Ticket Type step's number of days),
// but the API requires a duration unit on the schedule.
export const MULTI_DAY_DURATION_UNIT = "day"

export const CUT_OFF_UNIT_OPTIONS = [
  { value: "minute", labelKey: "experiences.ticketed_schedule.cut_off_minutes" },
  { value: "hour", labelKey: "experiences.ticketed_schedule.cut_off_hours" },
  { value: "day", labelKey: "experiences.ticketed_schedule.cut_off_days" }
]

// Must match formatSlotLabel in ScheduleExperienceModal/utils.js — duplicate detection compares labels.
export const SLOT_LABEL_FORMAT = "ddd MMM D, YYYY h:mm A"

// First entry is the display format; the rest are also accepted when typing a date.
export const DATE_PICKER_FORMATS = ["MMM D, YYYY", "MM/DD/YYYY"]

// Sunday-first, so a name's position is its dayjs day() index.
export const WEEKDAY_NAMES = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]

// The Preview calendar repeats a recurring season up to this many years ahead, as the booking page does.
export const PREVIEW_SEASON_YEARS_AHEAD = 2

// How far ahead the Preview calendar looks for the first bookable day to open on.
export const PREVIEW_FIRST_DAY_SEARCH_DAYS = 366 * PREVIEW_SEASON_YEARS_AHEAD
